import React from 'react';
import { Modal } from 'components/Modal/Modal';
import Button from 'components/foundry/Button/Button';

const ErrorModal = ({ handleCloseModal, hasWhiteLabels }) => {
  const contactString = hasWhiteLabels === "true" ? "support" : "GoCanvas";
  return (
<Modal
    backdropClass={"modal error-modal-overlay display-block"}
  >
    <div className="error-modal-title">
      <i className='foundry-icon icon--exclamation-triangle icon--red'></i>
      <div>Error</div>
    </div>
    <div className="text-body error-modal-content">Please try again later. If you continue to run into an issue, please contact {contactString}.</div>

    <div className="error-modal-cta">
      <Button
        onClick={handleCloseModal}
        additionalClass={"button--danger"}
      >
        <div>Got it</div>
      </Button>
    </div>
  </Modal>
  )
  
  }

export default ErrorModal
